import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@envs/environment';
import {
  DeliverableDynamicFieldSettingModel
} from '@app/features/scoping/models/scope-dynamic-field-setting.model';

@Injectable({
  providedIn: 'root',
})
export class DeliverableDynamicFieldSettingService {
  private readonly BASE_URL: string = environment.scopeApiUrl + 'deliverable/dynamic-field-setting';

  constructor(private http: HttpClient) {
  }

  getAll(): Observable<DeliverableDynamicFieldSettingModel[]> {
    return this.http.get<DeliverableDynamicFieldSettingModel[]>(`${this.BASE_URL}`);
  }

  get(id: number): Observable<DeliverableDynamicFieldSettingModel> {
    return this.http.get<DeliverableDynamicFieldSettingModel>(`${this.BASE_URL}/${id}`);
  }

  create(request: DeliverableDynamicFieldSettingModel): Observable<DeliverableDynamicFieldSettingModel> {
    return this.http.post<DeliverableDynamicFieldSettingModel>(`${this.BASE_URL}`, request);
  }

  update(id: number, request: DeliverableDynamicFieldSettingModel): Observable<DeliverableDynamicFieldSettingModel> {
    return this.http.put<DeliverableDynamicFieldSettingModel>(`${this.BASE_URL}/${id}`, request);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.BASE_URL}/${id}`);
  }

  getExternalSystemResource(request: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.BASE_URL}/external-system-resource`, request);
  }

  evictExternalSystemResource(request: any): Observable<void> {
    return this.http.post<void>(`${this.BASE_URL}/external-system-resource/cache-evict`,request);
  }
}
